const STORE = new Map()

function key(action, id) {
  return `${action}:${id}`
}

export function rateLimit(action, identifier, max, windowMs) {
  const k = key(action, identifier)
  const now = Date.now()
  const entry = STORE.get(k)

  if (!entry || now > entry.resetAt) {
    STORE.set(k, { count: 1, resetAt: now + windowMs })
    return { allowed: true, remaining: max - 1 }
  }

  if (entry.count >= max) {
    return { allowed: false, remaining: 0, retryAfterMs: entry.resetAt - now }
  }

  entry.count++
  return { allowed: true, remaining: max - entry.count }
}

export const RATE_LIMITS = {
  login: { max: 5, windowMs: 60_000 },
  chat: { max: 30, windowMs: 60_000 },
  upload: { max: 10, windowMs: 60_000 },
  agentRequest: { max: 5, windowMs: 60_000 },
}

export function checkRateLimit(action, identifier) {
  const cfg = RATE_LIMITS[action]
  if (!cfg) return { allowed: true, remaining: Infinity }
  return rateLimit(action, identifier, cfg.max, cfg.windowMs)
}
